import React from 'react';
import { isEmpty } from 'lodash';
import ReactSelect, { Props } from 'react-select';
import useTranslation from '../../../../Hooks/useTranslation';
import { joinClasses } from '../../../../Utils/className.util';
import styles from './Select.module.scss';
import { MenuPlacement } from '../../../../Modules/Base/Enums/MenuPlacement.enum';
import useSelectOptions from '../../../../Modules/Base/Hooks/useSelectOptions';

const REACT_SELECT_STYLES = {
	control: () => ({
		borderColor: 'red !important',
	}),
};

export interface SelectValueProps {
	value: string | number | object;
	label: string;
}

export interface SelectProps extends Props {
	name: string;
	hasError?: boolean;
	className?: string;
	options: SelectValueProps[];
	value?: SelectValueProps;
	shouldTranslateValues?: boolean;
	children?: React.ReactNode;
	placeholder?: string;
	portal?: boolean;
	isFixed?: boolean;
	isSearchable?: boolean;
	menuPlacement?: MenuPlacement;
}

const Select = React.forwardRef<any, React.PropsWithChildren<SelectProps>>(
	(
		{
			value,
			hasError = false,
			options,
			className,
			children,
			shouldTranslateValues = true,
			placeholder = 'base.shared.pick',
			portal,
			isFixed,
			isSearchable,
			menuPlacement,
			...props
		}: SelectProps,
		ref,
	) => {
		const { t } = useTranslation();

		const { translatedOptions } = useSelectOptions(
			options,
			shouldTranslateValues,
		);

		const translatedValue = isEmpty(value)
			? null
			: { label: t(value.label), value: value.value };

		return (
			<>
				<ReactSelect
					value={translatedValue}
					className={joinClasses([
						className,
						hasError ? styles.invalid : undefined,
					])}
					defaultValue={translatedValue}
					options={translatedOptions}
					classNamePrefix={'reactSelect'}
					styles={hasError ? REACT_SELECT_STYLES : undefined}
					ref={ref}
					menuPosition={isFixed ? 'fixed' : 'absolute'}
					menuPlacement={menuPlacement}
					placeholder={t(placeholder)}
					menuPortalTarget={portal ? document.body : undefined}
					isSearchable={isSearchable}
					{...props}
				/>
				{children}
			</>
		);
	},
);

export default Select;
